<template>
  <v-row align="baseline" :dense="dense">
    <slot name="label">
      <v-col cols="12" sm="6" :md="labelSize" v-if="label">
        <v-card class="d-flex" flat>
          <v-card flat>
            <span class="text-subtitle-1">{{ label }}</span>
            <div v-if="hint">
              <span class="text-caption">{{ hint }}</span>
            </div>
          </v-card>
        </v-card>
      </v-col>
    </slot>
    <v-col class="grow">
      <v-combobox
        v-model="computedValue"
        :items="items"
        chips
        :multiple="multiple"
        :delimiters="[',']"
        item-text="text"
        return-object
        :dense="dense"
      >
        <template #selection="data">
          <v-chip
            :key="JSON.stringify(data.item)"
            v-bind="data.attrs"
            :input-value="data.selected"
            :disabled="data.disabled"
            :close="multiple"
            :color="data.item.color"
            @click:close="data.parent.selectItem(data.item)"
            :small="dense"
            :dense="dense"
          >
            {{ data.item.text }}
          </v-chip>
        </template>
      </v-combobox>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "InputMultiSelect",
  components: {},
  mixins: [],
  props: {
    value: {
      required: true,
    },
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    label: {
      type: String,
      required: false,
      default: "",
    },
    labelSize: {
      type: Number,
      required: false,
      default: 5,
    },
    hint: {
      type: String,
      required: false,
      default: null,
    },
    multiple: {
      type: Boolean,
      required: false,
      default: true,
    },
    dense: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      // Material Colors Palete lighten-4
      // https://vuetifyjs.com/en/styles/colors/#material-colors
      colors: [
        "#FFCDD2",
        "#F8BBD0",
        "#E1BEE7",
        "#D1C4E9",
        "#C5CAE9",
        "#BBDEFB",
        "#B3E5FC",
        "#B2EBF2",
        "#B2DFDB",
        "#A5D6A7",
        "#C5E1A5",
        "#E6EE9C",
        "#FFF9C4",
        "#FFECB3",
        "#FFE0B2",
        "#FFCCBC",
        "#D7CCC8",
        "#CFD8DC",
        "#F5F5F5",
      ],
    };
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        let inputText;
        // If item not in listItem, add to it
        if (typeof val === "string") {
          inputText = val;
        } else {
          inputText = this.multiple
            ? val.map((item) => (typeof item === "string" ? item : item.text))
            : val.text;
        }
        const itemsText = this.items.map((item) => item.text);

        let newItem;
        if (this.multiple) {
          newItem = inputText.filter((x) => !itemsText.includes(x));
        } else if (!itemsText.includes(inputText)) {
          newItem = inputText;
        }
        if (newItem) {
          const newItemObj = { text: this.multiple ? newItem[0] : newItem, color: this.getColor() };
          this.$emit("update:items", [...this.items, newItemObj]);
          this.$emit("input", this.multiple ? [...this.value, newItemObj] : newItemObj);
        } else {
          this.$emit("input", val);
        }
        this.$emit("change");
      },
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    getColor() {
      const usedColors = this.items.map((v) => v.color);
      const nonUsedColors = this.colors.filter((v) => !usedColors.includes(v));
      let color;
      if (nonUsedColors.length) {
        color = nonUsedColors[Math.floor(Math.random() * nonUsedColors.length)];
      } else {
        color = this.colors[Math.floor(Math.random() * this.colors.length)];
      }
      return color;
    },
  },
};
</script>

<style></style>
